module.exports = __webpack_public_path__ + "static/media/Madfit_Website_05.2d2fa583.jpg";